<div *ngIf="!scanConnectedAutomation">
	<p-panel styleClass="p-panel-slimheight pt-3" *ngFor="let auto of connectedAutomation">
		<ng-template pTemplate="header">
			<div class="flex align-items-center">
				<span class="font-semibold">{{ auto.Name + ' - ' + auto.CrpClassName + ' - ' + automationStatus(auto) | truncate:[100]}}</span>
			</div>
		</ng-template>
		<ng-template pTemplate="icons">
			<p-button [disabled]="!currentDevice.CurrentlyOwned" icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}"
				tooltipPosition="bottom" (click)="editAlias(auto)" [text]="true" severity="secondary">
			</p-button>
		</ng-template>
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
				*ngIf="!automationOnline(auto) || !deviceConfiguredOnline()">
				<p-tag icon="pi cm-alert" [value]="(commandsUnavailableKey() | translate)" severity="warning"></p-tag>
			</div>
			<div class="col-12 flex align-items-center justify-content-center"
				[class]="this.screenWidth < MAX_MD_WIDTH ? 'grid mx-1' : 'grid pt-4 pb-0'">
				<div *ngFor="let command of getCommands(auto)"
					[class]="this.screenWidth < MAX_MD_WIDTH ? 'col-12 pb-0' : 'col-3'">
					<button type="button" pButton pRipple id="buttonDeviceCommand-{{command.Description}}"
						[disabled]="!automationOnline(auto) || !deviceConfiguredOnline()" label="{{ command.Description }}"
						class="p-button-primary text-xl font-normal" (click)="executeCommand(command.Id)">
					</button>
				</div>
			</div>
		</div>
	</p-panel>
</div>
<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
	*ngIf="scanConnectedAutomation && deviceConfiguredOnline()">
	<p-tag icon="pi cm-alert" [value]="('SCAN_CONNECTED_AUTOMATION' | translate)" severity="warning"></p-tag>
</div>
<div *ngIf="scanConnectedAutomation && deviceConfiguredOnline()">
	<div class="flex align-items-center justify-content-center w-full">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>

<!--<div class="grid mt-2">
	<div *ngIf="!onExtendedMobile()" class="col-6"></div>
	<div [class]="!onExtendedMobile() ? 'col-6' : 'col-12'">
		<button type="button" pButton pRipple label="{{ 'MANUAL_SCAN_AUTOMATION' | translate }}" [disabled]="scanConnectedAutomation"
			class="p-button-warning font-normal" (click)="manualScan()" icon="pi cm-reload" iconPos="left">
		</button>
	</div>
</div>-->